import { ACTIONS } from '_redux/actions';

const initialState = {
  isOpen: false,
  content: {
    leaderboard: [],
    cultureOptions: [],
  },
  contentLoading: true,
};

export default function leaderboard(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.LEADERBOARD.FETCH_ENTRIES:
      return {
        ...state,
        contentLoading: true,
      };

    case ACTIONS.LEADERBOARD.FETCH_ENTRIES_SUCCESS: {
      let items = [];

      // Adds or Sets the data based on the page number (0 sets, > 0 adds)
      if (state.content.leaderboard.length > 0 && action.payload.params.pageNumber > 0) {
        items = [...state.content.leaderboard, ...action.payload.data.leaderboard];
      } else {
        items = [...action.payload.data.leaderboard];
      }

      return {
        ...state,
        content: {
          ...action.payload.data,
          leaderboard: items,
        },
        contentLoading: false,
      };
    }

    case ACTIONS.LEADERBOARD.OPEN:
      return {
        ...state,
        isOpen: true,
      };

    case ACTIONS.LEADERBOARD.CLOSE:
      return {
        ...state,
        isOpen: false,
      };

    default:
      return state;
  }
}
